import React from 'react';
import 'styles/components/main/Contact.scss';
import { useNavigate } from 'react-router-dom';

const Contact = () => {

    const navigate = useNavigate();

    return (
        <section className='Contact' id='Contact'>
            <div className='contact-content'>
                <span className='fc_grey'>국방/공공 분야 소프트웨어 및<br className='lineBreak' /> 제품 개발에 </span>
                <span className='fc_black'>어질인소프트의 <br className='lineBreak' />최고 전문가들이 함께 하겠습니다</span>
            </div>
            <div className='container'>
                <button className='contact-contactBtn' onClick={() => navigate('/contact')}>
                    <span>Contact</span>
                </button>
            </div>
        </section>
    );
};

export default React.memo(Contact);